
const Columns = Formio.Components.components.phoneNumber;
const editForm = Formio.Components.components.nested.editForm;

/**
 * Here we will derive from the base component which all Form.io form components derive from.
 *
 * @param component
 * @param options
 * @param data
 * @constructor
 */

let phoneNumber;
export default class PhoneInput extends Columns {
    constructor(component, options, data) {
        super(component, options, data);
        this.value;
    }

    static schema() {
        return Columns.schema({
            label: "Téléphone",
            tableView: true,
            validate: {
                custom: "let val = input; if (val !== \"\") { const regex = /^(\\+?\\d{1,4})?(213|0)([2-4]\\d{7}|[5-7]\\d{8})$|^(\\+?\\d{1,4}[1-9]\\d{6,14})$/; if (!regex.test(val)) { return false; } }",
                customMessage: "Numéro de téléphone invalide",
                required: true
            },
            key: "telephone",
            type: "phoneinput",
            input: true,
            inputMask: ""
        });
    }

    // static get builderInfo() {
    //     return {
    //         title: "Téléphone",
    //         icon: "phone-square",
    //         group: "tickets",
    //         weight: 70,
    //         schema: PhoneInput.schema(),
    //     };
    // }

    render(children) {
        return super.render();
    }

    attach(element) {
        return super.attach(element);
    }
}
